import Component from '@glimmer/component';
import { GROUPING_TYPES } from '../../constants/chart/grouping';

export default class ChartNwGroupingSelectorComponent extends Component {
  get types() {
    return GROUPING_TYPES;
  }
}
